
import EoPodcastPlayerBody from './EoPodcastPlayerBody.vue'

export default {
  name: 'EoPodcastPlayer',
  components: {
    EoPodcastPlayerBody,
  },
  props: {
    /**
     * Enable / disable autoplay when a podcastepisode is selected
     */
    autoplay: {
      type: Boolean,
      default: false,
    },
    /**
     * Automaticaly go in extended mode when a podcastepisode is selected
     */
    autoExtend: {
      type: Boolean,
      default: true,
    },
    /**
     * Style: color of the interactive elements
     */
    accentColor: {
      type: String,
      default: 'primary',
    },
  },
  computed: {
    isPlaying () {
      return this.$store.getters['podcastPlayer/isPlaying']
    },
    isExtended () {
      return this.$store.getters['podcastPlayer/isExtended']
    },
    isClosed () {
      return this.$store.getters['podcastPlayer/isClosed']
    },
    seekerPosition () {
      return this.$store.getters['podcastPlayer/seeker']
    },
    jumpTo () {
      return this.$store.getters['podcastPlayer/jumpTo']
    },
    selectedEpisode () {
      return this.$store.getters['podcastPlayer/selectedEpisode']
    },
    hasSelectedEpisode () {
      return this.selectedEpisode ? true : false
    },
    episodeTitle () {
      return (this.selectedEpisode?.npo?.title + ' • ' + this.selectedEpisode?.npo?.content) || null
    },
    episodeAudioUrl () {
      return this.selectedEpisode?.npo?.enclosure?.url || null
    },
    episodeImage () {
      return this.selectedEpisode?.podcast?.imageUrl || null
    },
    episodeDate () {
      return this.selectedEpisode?.npo?.date || null
    },
    episodeDescription () {
      return this.selectedEpisode?.npo?.description || null
    },
    episodeDuration () {
      return this.selectedEpisode?.npo?.duration || 0
    },
    episodeShareUrl () {
      return this.selectedEpisode?.npo?.shareWhatsAppUrl || null
    },
    episodesUrl () {
      return this.selectedEpisode?.podcast?.episodesUrl || null
    },
  },
  watch: {
    /** 
     * Automatically extend player when the user selected an episode
     */
    selectedEpisode: {
      handler (nextEpisode) {
        if (nextEpisode && this.autoExtend) {
          this.openPlayer()
          this.extendPlayer()
        }
      },
      immediate: true,
    },
    /** 
     * Automatically collapse player when the user navigates to another page
     */
    '$route' () {
      this.collapsePlayer()
    },
  },
  methods: {
    /**
     * Audio methods
     */
    setGoNativePlayer (state) {
      if (navigator.userAgent.includes('GoNativeIOS')) {
        this.goNativePlaying = state
        window.location.href = `gonative://backgroundAudio/${state}`
      }
    },
    onAudioPlay () {
      if (!this.isClosed) {
        this.$store.dispatch('podcastPlayer/setClosed', false)
      }
      this.$store.dispatch('podcastPlayer/setPlaying', true)
      this.setGoNativePlayer('start')
    },
    onAudioPause () {
      this.$store.dispatch('podcastPlayer/setPlaying', false)
      this.setGoNativePlayer('stop')
    },
    onAudioSource () {
      if (!this.isClosed) {
        this.$store.dispatch('podcastPlayer/setClosed', false)
      }
    },
    onAudioProgress (value) {
      this.$store.dispatch('podcastPlayer/setSeeker', Math.floor(value))
    },
    /**
     * UI methods
     */
    openPlayer () {
      this.$store.dispatch('podcastPlayer/setClosed', false)
    },
    stopAndClosePlayer () {
      this.$store.dispatch('podcastPlayer/setPlaying', false)
      this.$store.dispatch('podcastPlayer/setExtended', false)

      setTimeout(() => {
        this.$store.dispatch('podcastPlayer/setClosed', true)
        setTimeout(() => {
          this.$store.dispatch('podcastPlayer/clearQueue')
        }, 500)
      }, 350)
    },
    extendPlayer () {
      this.$store.dispatch('podcastPlayer/setExtended', true)
    },
    collapsePlayer () {
      this.$store.dispatch('podcastPlayer/setExtended', false)
    },
  },
}
